import BaseStep from './BaseStep.js';
import { syncChoicesSelectValue } from '../../helpers/ChoicesSelectValue.js';

export default class ManageSteps extends BaseStep {
    _init() {
        this._MultiStepForms.Hook.addAction('addEvents', () => {
            this.#nextStepHandler();
            this.#previousStepHandler();
        });

		this._MultiStepForms.Hook.addAction('init', () => {
			this._MultiStepForms.formWrapper.style.setProperty('--steps', this._MultiStepForms.formSteps.length - 1)
			this._MultiStepForms.formSteps.forEach((step, index) => {
				step.style.setProperty(`--step`, index + 1 );
			})
		})

		//import gsap initially to avoid stopping of animation
		this._MultiStepForms.Hook.addAction('init', async () => {
			const gsap = await import(/* webpackChunkName: "gsap" */ 'gsap');
		});
    }

    #nextStepHandler() {
        this._MultiStepForms.handleEvent('keypress', 'form', (event, form) => {
            if (event.key === 'Enter' && !event.target.matches('select,textarea,input[type="file"]')) {
                event.preventDefault();

                if (!this._MultiStepForms.element(event.target, 'input[type="search"]')) {
                    form?.querySelector('.submit-form')?.click();
                }
            }
        });

        this._MultiStepForms.handleEvent('click', '.form-header .breadcrumbs .breadcrumb-label', (event, breadcrumb) => {
            event.preventDefault();

            if (!breadcrumb?.dataset?.step) return;

            const step = parseInt(breadcrumb.dataset.step);

            this.goToStep(step);
        });

        this._MultiStepForms.handleEvent('click', '.submit-form', (event, button) => {

            event.preventDefault();

            const form = button.closest('form');

            this._MultiStepForms.clearErrors();

            const isValid = this._MultiStepForms.validateFields(form);
            // const isValid = true;

            if (!isValid) return;

            let formAction = form.querySelector('input[name="action"]')?.value || '';

            const formId = form?.dataset?.formId || null;

            let canSubmit = formAction !== '';
            if (formId) {
                const forms = this._MultiStepForms.formWrapper.querySelectorAll(`form[data-form-id="${formId}"]`);

                const lastForm = forms[forms.length - 1];

                canSubmit = form === lastForm;

				if (form.querySelector('.is-edit')){
					canSubmit = false;

					this._MultiStepForms.error(null, 'Please confirm changes before submitting.', form);
					return;
				}

                if (canSubmit) {
                    this.#addFieldsIntoLastForm(forms, lastForm);
                }

                this._MultiStepForms.Hook.doAction('identFormsSubmit', form, formAction, forms);
            }
            formAction = form.querySelector('input[name="action"]')?.value || '';
            const sendSubmitRequest = this._MultiStepForms.Hook.applyFilters('sendSubmitRequest', formAction !== '' && canSubmit, form, formAction);

            if (canSubmit) {
				if (!sendSubmitRequest) return;

				this._MultiStepForms.Hook.doAction('beforeSubmitRequestSent', sendSubmitRequest, form, formAction)

                this._MultiStepForms.submitForm(form, formAction)
                    .then((response) => {
                        this._MultiStepForms.Hook.doAction('submitFormSuccess', response, form, formAction);
                        this.nextStep();
                    })
                    .catch((response) => {
                        this._MultiStepForms.Hook.doAction('submitFormFail', response, form, formAction);
						if (response) {
							if (response?.message) {
								let field = response?.field || null;
								let fields = []
								if (field) {
									fields = this._MultiStepForms.formWrapper.querySelectorAll(`input[name="${field}"],select[name="${field}"],textarea[name="${field}"]`);

									if (!field) {
										fields = this._MultiStepForms.formWrapper.querySelectorAll(`input[data-uid="${field}"],select[data-uid="${field}"],textarea[data-uid="${field}"]`);
									}
								}

								if (fields.length){
									fields.forEach((field, index) => {
										this._MultiStepForms.error(field, index === 0 ? response.message : '', null)
									})
								}
								this._MultiStepForms.error(field, response.message, form)
							} else if (response?.messages && Array.isArray(response?.messages)) {
								for (const index in response.messages) {
									const message = response.messages[index];
									let field = null;
									if (response.fields) {
										field = response.fields[index] || null;
									}

									let fields = []
									if (field) {
										fields = this._MultiStepForms.formWrapper.querySelectorAll(`input[name="${field}"],select[name="${field}"],textarea[name="${field}"]`);

										if (!field) {
											fields = this._MultiStepForms.formWrapper.querySelectorAll(`input[data-uid="${field}"],select[data-uid="${field}"],textarea[data-uid="${field}"]`);
										}
									}

									if (fields.length){
										fields.forEach((field, index) => {
											this._MultiStepForms.error(field, index === 0 ? message : '', null)
										})
									}

									this._MultiStepForms.error(null, message, form)
								}
							}
						} else {
							this._MultiStepForms.error(null, 'Something went wrong.', form)
						}
                    })
                    .finally(() => {
                        this._MultiStepForms.Hook.doAction('submitFormAfterSubmit', form, formAction);
                    });
            } else {
                this.nextStep();
            }
        });
    }

    #previousStepHandler() {
        this._MultiStepForms.handleEvent('click', '.button-prev-step', (event, button) => {
            event.preventDefault();
            this.prevStep();
        })
    }

    async nextStep() {
        const currentStep = this._MultiStepForms.currentStep;
        const nextStep = this._MultiStepForms.currentStep + 1;

        const doNextStep = this._MultiStepForms.Hook.applyFilters('doNextStep', true, currentStep, nextStep);

        if (!doNextStep) return;

        const currentFormWrapper = this._MultiStepForms.formSteps[currentStep - 1] || null;
        const nextFormWrapper = this._MultiStepForms.formSteps[currentStep] || null;
        const next2FormWrapper = this._MultiStepForms.formSteps[currentStep + 1] || null;

        if (!currentFormWrapper || !nextFormWrapper) return;

		this._MultiStepForms.formSteps.forEach(f => {
			f.classList.remove('current-step', 'next-step', 'prev-step');
		});

		next2FormWrapper?.classList.add('next-step');
		nextFormWrapper?.classList.add('next-step');
		currentFormWrapper?.classList.add('prev-step');

		this._MultiStepForms.Hook.doAction('nextStep', currentStep, nextStep, currentFormWrapper, nextFormWrapper);

		setTimeout(() => {
			nextFormWrapper?.classList.add('current-step');
			nextFormWrapper?.classList.remove('next-step');
		}, 10)

		window.scrollTo(0,0);

		nextFormWrapper.style.display = '';
		setTimeout(() => {
			currentFormWrapper.style.display = 'none';
		}, 300)

        this._MultiStepForms.prevStep = currentStep;

        this._MultiStepForms.currentStep ++;
	}

    prevStep() {
        const currentStep = this._MultiStepForms.currentStep;
        const prevStep = this._MultiStepForms.currentStep - 1;

		const currentFormWrapper = this._MultiStepForms.formSteps[currentStep - 1] || null;
        const prevFormWrapper = this._MultiStepForms.formSteps[prevStep - 1] || null;
        const prev2FormWrapper = this._MultiStepForms.formSteps[prevStep - 2] || null;

        if (!currentFormWrapper || !prevFormWrapper) return;

		this._MultiStepForms.Hook.doAction('prevStep', currentStep, prevStep, currentFormWrapper, prevFormWrapper);

		const doPrevStep = this._MultiStepForms.Hook.applyFilters('doPrevStep', true, currentStep, prevStep);

		if (!doPrevStep) return;

		this._MultiStepForms.formSteps.forEach(f => {
			f.classList.remove('current-step', 'next-step', 'prev-step');
		});

		window.scrollTo(0,0)

		currentFormWrapper?.classList.add('next-step');
		prev2FormWrapper?.classList.add('prev-step');
		prevFormWrapper?.classList.add('prev-step');

		setTimeout(() => {
			prevFormWrapper?.classList.add('current-step');
			prevFormWrapper?.classList.remove('prev-step');
		}, 10)

		prevFormWrapper.style.display = '';
		setTimeout(() => {
			currentFormWrapper.style.display = 'none';
		}, 300)

        this._MultiStepForms.prevStep = currentStep;

        this._MultiStepForms.currentStep --;
    }

    goToStep(step) {
        const currentStep = this._MultiStepForms.currentStep;

        const allowGoToStep = this._MultiStepForms.Hook.applyFilters(
            'allowGoToStep',
            true,
            currentStep,
            step
        );
        if (!allowGoToStep) {
            return;
        }

        const currentFormWrapper = this._MultiStepForms.formSteps[currentStep - 1] || null;
        const nextFormWrapper = this._MultiStepForms.formSteps[step - 1] || null;

        if (!currentFormWrapper || !nextFormWrapper) return;

        currentFormWrapper.style.display = 'none';
        nextFormWrapper.style.display = '';

        this._MultiStepForms.Hook.doAction('goToStep', currentStep, step, currentFormWrapper, nextFormWrapper);

        this._MultiStepForms.prevStep = currentStep;

        this._MultiStepForms.currentStep = step;
    }

    /**
     * @param {HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement} field
     * @returns {string}
     */
    #getSignupFieldMergeValue(field) {
        if (!field?.name) {
            return '';
        }

        if (field.type === 'checkbox' || field.type === 'radio') {
            return field.checked ? String(field.value || '') : '';
        }

        if (field.nodeName === 'SELECT' && field.closest('.choices')) {
            return String(syncChoicesSelectValue(field) || '').trim();
        }

        return String(field.value ?? '').trim();
    }

    /**
     * @param {HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement} field
     * @returns {boolean}
     */
    #isSignupFieldMergeEmpty(field) {
        return this.#getSignupFieldMergeValue(field) === '';
    }

    /**
     * @param {ParentNode} scope
     * @param {HTMLElement} hiddenFieldsContainer
     * @param {Map<string, string>} best
     */
    #applySignupHiddenFieldOverrides(scope, hiddenFieldsContainer, best) {
        const hostForm = hiddenFieldsContainer.closest('form');

        best.forEach((val, name) => {
            const removeScope = hostForm || scope;
            removeScope.querySelectorAll(`[name="${name}"]`).forEach((el) => el.remove());
            const hid = document.createElement('input');
            hid.type = 'hidden';
            hid.name = name;
            hid.value = val;
            hiddenFieldsContainer.append(hid);
        });
    }

    /**
     * LevCharity multi-step: when the last submitted form is not the step that holds partner fields, merge misses them.
     * Copies non-empty `chaination_event_*` (and same pattern for other themes) from merge-root wrappers into hidden inputs.
     * Themes mark a wrapper with `data-levcharity-signup-merge-root` (preferred) or legacy `data-chaination-signup-event-fields`.
     *
     * @param {ParentNode} wrapper
     * @param {HTMLElement} hiddenFieldsContainer
     */
    #appendLevcharitySignupMergeHiddenFields(wrapper, hiddenFieldsContainer) {
        const selector =
            'input[name^="chaination_event_"],select[name^="chaination_event_"],textarea[name^="chaination_event_"],input[name^="chaination_hide_"],input[name^="chaination_address_"]';

        if (!wrapper.querySelector(selector)) {
            return;
        }

        /** @type {Map<string, string>} */
        const best = new Map();

        wrapper.querySelectorAll(selector).forEach((field) => {
            const { name } = field;
            if (!name) {
                return;
            }

            const val = this.#getSignupFieldMergeValue(field);
            if (val === '') {
                return;
            }
            best.set(name, val);
        });

        this.#applySignupHiddenFieldOverrides(wrapper, hiddenFieldsContainer, best);
    }

    /**
     * Team create flow: review steps duplicate `teams_goal` (and related) with empty values, which blocked merge.
     *
     * @param {ParentNode} wrapper
     * @param {HTMLElement} hiddenFieldsContainer
     */
    #appendTeamCreateSignupMergeHiddenFields(wrapper, hiddenFieldsContainer) {
        const selector = [
            'select[name="teams_goal"]',
            'input[name="team_campaign_goal_other_amount"]',
            'input[name="team_campaign_goal_other_name"]',
            'input[name="team_name"]',
            'textarea[name="team_message"]',
            'textarea[name="team_campaign_subtitle"]',
        ].join(',');

        /** @type {Map<string, string>} */
        const best = new Map();

        wrapper.querySelectorAll(selector).forEach((field) => {
            if (!field.name) {
                return;
            }
            const val = this.#getSignupFieldMergeValue(field);
            if (val === '') {
                return;
            }
            best.set(field.name, val);
        });

        this.#applySignupHiddenFieldOverrides(wrapper, hiddenFieldsContainer, best);
    }

    #addFieldsIntoLastForm(forms, to) {
        to.querySelector('.hidden-fields')?.remove();

        const hiddenFieldsContainer = document.createElement('div');
        hiddenFieldsContainer.classList.add('hidden-fields');

        hiddenFieldsContainer.setAttribute('style', 'display:none!important;visibility:hidden!important;opacity:0!important;z-index:-99999999!important')

        const mergedRadioNames = new Set();

        for (const form of forms) {

            if (form === to || [...forms].indexOf(form) > [...forms].indexOf(to)) continue;

            const fields = form.querySelectorAll('input,textarea,select');

            for (const field of fields) {
                if (!field.name) {
                    continue;
                }

                if (field.type === 'radio') {
                    if (mergedRadioNames.has(field.name)) {
                        continue;
                    }
                    mergedRadioNames.add(field.name);

                    if (hiddenFieldsContainer.querySelector(`[name="${field.name}"]`)) {
                        continue;
                    }

                    // Prefer a selection on the submit (last) form when present.
                    if (to.querySelector(`input[type="radio"][name="${field.name}"]:checked`)) {
                        continue;
                    }

                    // Otherwise take the most recent earlier-step selection (scan reverse),
                    // so an unchecked earlier duplicate group does not block a later pick.
                    let checked = null;
                    const toIndex = [...forms].indexOf(to);
                    for (let i = toIndex - 1; i >= 0; i--) {
                        checked = forms[i].querySelector(
                            `input[type="radio"][name="${field.name}"]:checked`
                        );
                        if (checked) {
                            break;
                        }
                    }

                    if (!checked) {
                        continue;
                    }

                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = field.name;
                    input.value = checked.value;
                    input.setAttribute('readonly', true);
                    hiddenFieldsContainer.append(input);
                    continue;
                }

                if (hiddenFieldsContainer.querySelector(`[name="${field.name}"]`)) {
                    continue;
                }

                const targetField = to.querySelector(`[name="${field.name}"]`);
                if (targetField && !this.#isSignupFieldMergeEmpty(targetField)) {
                    continue;
                }

                const sourceValue = this.#getSignupFieldMergeValue(field);
                if (sourceValue === '') {
                    continue;
                }

                if (field.closest('.choices')){
					if (field.name === 'search_terms') continue;

					if (field.nodeName === 'SELECT') {
						const input = document.createElement('input');
						input.name = field.name;
						input.setAttribute('readonly', true);
						input.value = sourceValue;

						hiddenFieldsContainer.append(input);
					}
                } else {
					let input;
					if (field.nodeName === 'SELECT' || (field.nodeName === 'INPUT' && ['radio', 'checkbox'].includes(field.type)) ) {
						input = document.createElement('input');
						input.type = 'text';
					} else {
						input = document.createElement(field.nodeName.toLowerCase());

						if (input.closest('input')) {
							input.type = field.type;
						}
					}

					input.name = field.name;
					input.required = field.required;

					if (field.type === 'file') {
						input.files = field.files;
					} else if (field.type === 'checkbox'){
						if (!field.checked) {
							continue;
						}
						input.value = field.value;
					} else {
						input.value = sourceValue;
					}

					input?.setAttribute('readonly', true);

					if (input) {
						hiddenFieldsContainer.append(input);
					}

                }

            }
        }

        this.#appendLevcharitySignupMergeHiddenFields(this._MultiStepForms.formWrapper, hiddenFieldsContainer);
        this.#appendTeamCreateSignupMergeHiddenFields(this._MultiStepForms.formWrapper, hiddenFieldsContainer);

        to.append(hiddenFieldsContainer);
    }
}
